import styled from 'styled-components';
import { ImagePartial } from '@storefront/lib-global/partials/image';
import { TypographyStyles, colours, media, spacing, zProductBadge } from '@storefront/lib-global/stylings';

export const Price = styled.div`
  align-items: center;
  column-gap: ${spacing.XXXS};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 30px;
  padding: 0px;
`;

export const ProductAndPromotionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProductItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXS};
  padding-bottom: ${spacing.XXXS};
  position: relative;

  @media ${media.greaterThan('lg')} {
    gap: 10px;
    padding-bottom: ${spacing.S};
  }
  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const ProductLink = styled.a`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXS};

  @media ${media.greaterThan('lg')} {
    gap: ${spacing.XXS};
  }
`;

export const ProductName = styled.span`
  -webkit-box-orient: vertical;
  display: block;
  /* stylelint-disable value-no-vendor-prefix */
  display: -webkit-box;
  height: fit-content;
  -webkit-line-clamp: 2;
  margin: 0;
  min-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  width: inherit;
  ${TypographyStyles.Headings.H4SemiBold}
  @media ${media.greaterThan('lg')} {
    min-height: 48px;
  }
`;

export const ProductCategory = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  min-height: 36px;
  width: inherit;
  @media ${media.greaterThan('lg')} {
    min-height: 44px;
  }
  & p {
    ${TypographyStyles.Body.Tiny.Regular}
    -webkit-box-orient: vertical;
    display: block;
    display: -webkit-box;
    font-size: 14px;
    height: fit-content;
    -webkit-line-clamp: 1;
    line-height: 18px;
    margin: 0;
    min-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
    width: inherit;
    @media ${media.greaterThan('lg')} {
      font-size: 14px;
      line-height: 22px;
      min-height: 22px;
    }
  }
`;

export const ProductColourSelectorSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
  margin-top: auto;

  @media ${media.greaterThan('lg')} {
    gap: ${spacing.XS};
  }
`;

export const ProductColourSelector = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.XXXS};
`;

export const ProductColour = styled.a<{ $isSelectedColorLink: boolean }>`
  border: ${({ $isSelectedColorLink }) => $isSelectedColorLink && `1px solid ${colours.BLACK}`};
  cursor: pointer;
  height: 32px;
  position: relative;
  width: 32px;

  :active,
  :target {
    border: solid 1px ${colours.BLACK};
  }

  @media ${media.greaterThan('lg')} {
    height: 40px;
    width: 40px;
  }
`;

export const ProductMoreColors = styled.a`
  ${TypographyStyles.Body.Tiny.SemiBold}
  color: ${colours.BLACK};
  cursor: pointer;
  letter-spacing: 0px;
  padding: 2px 0;
  text-decoration: none;
`;

export const ImagePartialStyled = styled(ImagePartial)`
  margin-bottom: ${spacing.XXXXXS};
`;

export const ImageAndBadgeContainer = styled.div`
  position: relative;
`;

export const QuickBuyButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  height: 44px;
  margin: 6px;
  padding: 0;
  padding: ${spacing.XXXXS};
  position: absolute;
  width: 44px;
  z-index: ${zProductBadge};

  @media screen and (prefers-reduced-motion: reduce) {
    svg {
      transition: none;
    }
  }

  svg {
    transition: fill 0.3s ease;
  }

  &:hover,
  &:focus {
    background-color: ${colours.BLACK};

    svg {
      filter: brightness(0) invert(1);
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }

  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;
